import View from "./company-form.view";
import CreatePresenter from "./company-form-create.presenter";
import EditPresenter from "./company-form-edit.presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.registration.company.create",
    url: "/nova",
    views: {
      "content@app": ConnectComponent(View, CreatePresenter)
    },
    data: {
      authorization: context => context.user.is_admin
    }
  },
  {
    name: "app.registration.company.edit",
    url: "/:companyUuid/editar",
    views: {
      "content@app": ConnectComponent(View, EditPresenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/index.js